// extracted by mini-css-extract-plugin
module.exports = {"Inf_msg_list":"Inf_msg_list--2Kbn7"};